export const REDIRECT_QUERY_PARAM = 'redirect';

const isInternalPath = (value: string): boolean =>
  value.startsWith('/') && !value.startsWith('//') && !value.includes('\\');

export const getSafeRedirectPath = (
  value: string | string[] | undefined
): string | null => {
  const candidate = Array.isArray(value) ? value[0] : value;
  return candidate && isInternalPath(candidate) ? candidate : null;
};
